import React from "react";
import bannerBg from "../assets/ads/banner2.png";
import greenLeaf from "../assets/ads/image.png";
import tomatoCorner from "../assets/special_offer_tomato_corner.png";

const FullWidthBanner = () => {
  return (
    <section className="relative w-full overflow-hidden select-none min-h-[440px] md:min-h-[500px] lg:min-h-[560px] flex items-center py-16 md:py-24">
      {/* Self-contained animations for premium interactivity */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
        @keyframes float-leaf-banner {
          0%, 100% { transform: translateY(0) rotate(20deg) scale(1); }
          50% { transform: translateY(-12px) rotate(26deg) scale(1.05); }
        }
        @keyframes pulse-glow-badge {
          0%, 100% { transform: scale(1) rotate(12deg); box-shadow: 0 10px 25px rgba(242, 94, 28, 0.3); }
          50% { transform: scale(1.06) rotate(8deg); box-shadow: 0 15px 35px rgba(242, 94, 28, 0.5); }
        }
        @keyframes bounce-subtle {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
        }
        .animate-float-leaf-banner {
          animation: float-leaf-banner 5s infinite ease-in-out;
        }
        .animate-pulse-glow-badge {
          animation: pulse-glow-badge 4s infinite ease-in-out;
        }
        .animate-bounce-subtle {
          animation: bounce-subtle 3.2s infinite ease-in-out;
        }
      `,
        }}
      />

      {/* Background Banner Image */}
      <div className="absolute inset-0 z-0">
        <img
          src={bannerBg}
          alt="Ad banner background with pizza"
          className="w-full h-full object-cover object-center md:object-right"
        />
        {/* Dark radial to linear gradient overlay for maximum text contrast */}
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/30 md:from-black/90 md:via-black/60 md:to-transparent" />
      </div>

      {/* CSS-based Glowing Promo Badge (Replaces the cropped and blurry top-left image badge) */}
      <div className="absolute top-8 left-6 md:top-12 md:left-16 z-25 animate-pulse-glow-badge bg-[#f25e1c] text-white w-24 h-24 md:w-28 md:h-28 rounded-full flex flex-col items-center justify-center border-2 border-dashed border-white/50 shadow-2xl select-none">
        <span className="text-[10px] md:text-[11px] font-mono font-bold tracking-widest text-orange-200">GET</span>
        <span className="text-2xl md:text-3xl font-black font-sans leading-none tracking-tight">45%</span>
        <span className="text-[10px] md:text-[11px] font-bold text-orange-200">OFF</span>
      </div>

      {/* Decorative blurry green leaf (bottom left) */}
      <div className="absolute -bottom-12 -left-10 w-28 md:w-36 opacity-60 pointer-events-none select-none z-10 blur-[3px] -rotate-[35deg]">
        <img
          src={greenLeaf}
          alt="Floating leaf bottom-left"
          className="w-full h-auto object-contain"
        />
      </div>

      {/* Tomato & Basil Corner Decoration (Seamless black-background image) */}
      <div className="absolute -bottom-10 -right-10 w-36 md:w-52 lg:w-64 opacity-90 pointer-events-none select-none z-20">
        <img
          src={tomatoCorner}
          alt="Fresh tomato decoration"
          className="w-full h-auto object-contain drop-shadow-[0_12px_25px_rgba(0,0,0,0.65)]"
        />
      </div>

      {/* Floating green leaf over the pizza (center-right) */}
      <div className="hidden md:block absolute right-[28%] lg:right-[32%] top-[40%] lg:top-[45%] w-24 lg:w-32 z-20 pointer-events-none animate-float-leaf-banner">
        <img
          src={greenLeaf}
          alt="Floating fresh leaf"
          className="w-full h-auto object-contain drop-shadow-[0_10px_20px_rgba(0,0,0,0.55)]"
        />
      </div>

      {/* White bubble tag over the pizza */}
      <div className="absolute right-[8%] sm:right-[15%] md:right-[20%] lg:right-[24%] top-[14%] sm:top-[16%] md:top-[20%] z-20 animate-bounce-subtle">
        <div className="relative bg-white text-[#f25e1c] font-black text-[11px] sm:text-xs md:text-sm px-4 py-2 rounded-full shadow-[0_10px_25px_rgba(0,0,0,0.25)] border border-orange-100 flex items-center justify-center whitespace-nowrap">
          🍕 Hand Tossed Crust
          {/* Small point on bubble */}
          <div className="absolute bottom-[-5px] left-[45%] w-2.5 h-2.5 bg-white rotate-45 border-r border-b border-orange-100" />
        </div>
      </div>

      {/* Content Container */}
      <div className="max-w-7xl mx-auto w-full px-6 md:px-12 lg:px-20 relative z-10">
        
        {/* Left Column: Promotion Info */}
        <div className="w-full md:w-[55%] lg:w-[48%] flex flex-col items-start text-left">
          
          {/* Welcome Tag */}
          <span className="text-xs sm:text-sm tracking-[0.25em] text-[#e21b1b] font-extrabold uppercase mb-3 drop-shadow-sm font-mono">
            WELCOME TO FLAKES
          </span>

          {/* Heading with spelling corrected */}
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-[52px] font-black text-white leading-[1.1] tracking-tight uppercase mb-4 drop-shadow-md font-sans">
            TODAY'S SPECIAL DISH
          </h2>

          {/* Subtitle with spelling corrected */}
          <p className="text-xs sm:text-sm text-[#f25e1c] font-black uppercase tracking-[0.2em] mb-8 font-mono">
            LIMITED TIME OFFER
          </p>

          {/* Red button with white square arrow box */}
          <a
            href="#menu"
            className="inline-flex items-center bg-[#e21b1b] hover:bg-[#c81616] text-white text-xs font-black tracking-widest uppercase pl-6 rounded transition-all duration-300 group shadow-lg hover:shadow-xl hover:shadow-[#e21b1b]/15 transform hover:-translate-y-0.5 active:translate-y-0 select-none"
          >
            <span>ORDER NOW</span>
            <div className="w-12 h-12 bg-white text-[#e21b1b] flex items-center justify-center ml-6 border-l border-white/10">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="3.5"
                className="w-4 h-4 transform group-hover:translate-x-1 transition-transform"
              >
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </div>
          </a>
          
        </div>
      </div>
    </section>
  );
};

export default FullWidthBanner;
